// extracted by mini-css-extract-plugin
export default {"main_nav":"index_main_nav_-31FD","user":"index_user_ZyyEu","search":"index_search_fjpk7","logo":"index_logo_Ynkxm"};